import React, { Fragment } from 'react';
import { IndexPageSection, DayaxeInstaWidget} from '../index';
import { MomentsDescription } from "./styles";

const DayAxeMoments = () => (
  <div></div>
  // <IndexPageSection heading={<Fragment><span><a href="https://www.instagram.com/explore/tags/dayaxe/?hl=en" target="_blank" rel="noopener noreferrer">#DayAxe</a></span> Moments</Fragment>}>
  //   <MomentsDescription>
  //     Share moments from your own day stay. Mention <a href="https://www.instagram.com/dayaxeapp/?hl=en" target="_blank" rel="noopener noreferrer">@dayaxeapp</a> on Instagram for a chance to be featured!
  //   </MomentsDescription>
  //   <DayaxeInstaWidget />
  // </IndexPageSection>
);

export default DayAxeMoments;
